import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import './CardComponent.css'; // Import CSS file for styling
import { Link } from 'react-router-dom';

const CardComponent = ({ title, value, bgColor, image }) => {

   // Automatically decide route based on title
  const getRoute = (title) => {
    if (!title) return '#';
    const normalized = title.toLowerCase();

    if (normalized.includes('farmer')) return '/farmers';
    if (normalized.includes('supplier')) return '/suppliers';
    if (normalized.includes('consultant')) return '/consultants';
    if (normalized.includes('admin')) return '/admins';
    if (normalized.includes('crop')) return '/crops';
    if (normalized.includes('budget')) return '/admins';
    if (normalized.includes('region')) return '/regions';
    if (normalized.includes('request')) return '/requests';
    if (normalized.includes('task')) return '/tasks';
    
    return '#'; // default route
  };

   const route = getRoute(title);

  return (
    <Link 
      to={route} 
      className="card-link" 
      style={{ textDecoration: 'none', color: 'inherit' }}
    >
    <Card className="mb-4 card-component" style={{ backgroundColor: bgColor}}>
       <Row className="align-items-center">
      {/* Left side with value and title */}
      <Col xs={8} className="text-start">
        <Card.Title className="card-title">{value}</Card.Title>
        <Card.Text>{title}</Card.Text>
      </Col>

      {/* Right side with image */}
      <Col xs={4} className="text-end">
        {image && <img src={image} alt={title} className="card-image" />}
      </Col>
    </Row>
    </Card>
    </Link>
  );
};

export default CardComponent;
